import { Observable } from 'rxjs';
import { InjectionToken, Attribute, Directive, ElementRef, EventEmitter, Inject, Output, Injectable, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const MUTATION_OBSERVER_INIT = new InjectionToken('MutationObserver config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} element
 * @param {?} attribute
 * @return {?}
 */
function booleanAttribute(element, attribute) {
    return element.getAttribute(attribute) !== null || undefined;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} __0
 * @return {?}
 */
function mutationObserverInitFactory({ nativeElement, }) {
    /** @type {?} */
    const attributeFilterAttr = nativeElement.getAttribute('attributeFilter');
    /** @type {?} */
    const attributeFilter = attributeFilterAttr
        ? attributeFilterAttr.split(',').map(attr => attr.trim())
        : undefined;
    return {
        attributeFilter,
        attributeOldValue: booleanAttribute(nativeElement, 'attributeOldValue'),
        attributes: booleanAttribute(nativeElement, 'attributes'),
        characterData: booleanAttribute(nativeElement, 'characterData'),
        characterDataOldValue: booleanAttribute(nativeElement, 'characterDataOldValue'),
        childList: booleanAttribute(nativeElement, 'childList'),
        subtree: booleanAttribute(nativeElement, 'subtree'),
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0 = mutationObserverInitFactory;
// @dynamic
class MutationObserverDirective extends MutationObserver {
    /**
     * @param {?} __0
     * @param {?} config
     * @param {?} _1
     * @param {?} _2
     * @param {?} _3
     * @param {?} _4
     * @param {?} _5
     * @param {?} _6
     * @param {?} _7
     */
    constructor({ nativeElement }, config, _1, _2, _3, _4, _5, _6, _7) {
        super(records => {
            this.waMutationObserver.emit(records);
        });
        this.waMutationObserver = new EventEmitter();
        this.observe(nativeElement, config);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.disconnect();
    }
}
/** @nocollapse */
MutationObserverDirective.ɵfac = function MutationObserverDirective_Factory(t) { return new (t || MutationObserverDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(MUTATION_OBSERVER_INIT), ɵngcc0.ɵɵinjectAttribute('attributeFilter'), ɵngcc0.ɵɵinjectAttribute('attributeOldValue'), ɵngcc0.ɵɵinjectAttribute('attributes'), ɵngcc0.ɵɵinjectAttribute('characterData'), ɵngcc0.ɵɵinjectAttribute('characterDataOldValue'), ɵngcc0.ɵɵinjectAttribute('childList'), ɵngcc0.ɵɵinjectAttribute('subtree')); };
/** @nocollapse */
MutationObserverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MutationObserverDirective, selectors: [["", "waMutationObserver", ""]], outputs: { waMutationObserver: "waMutationObserver" }, exportAs: ["MutationObserver"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: MUTATION_OBSERVER_INIT,
                deps: [ElementRef],
                useFactory: ɵ0
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
MutationObserverDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MUTATION_OBSERVER_INIT,] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['attributeFilter',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['attributeOldValue',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['attributes',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['characterData',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['characterDataOldValue',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['childList',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['subtree',] }] }
];
MutationObserverDirective.propDecorators = {
    waMutationObserver: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MutationObserverDirective, [{
        type: Directive,
        args: [{
                selector: '[waMutationObserver]',
                exportAs: 'MutationObserver',
                providers: [
                    {
                        provide: MUTATION_OBSERVER_INIT,
                        deps: [ElementRef],
                        useFactory: ɵ0
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MUTATION_OBSERVER_INIT]
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['attributeFilter']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['attributeOldValue']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['attributes']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['characterData']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['characterDataOldValue']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['childList']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['subtree']
            }] }]; }, { waMutationObserver: [{
            type: Output
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class MutationObserverService extends Observable {
    /**
     * @param {?} __0
     * @param {?} config
     */
    constructor({ nativeElement }, config) {
        super(subscriber => {
            /** @type {?} */
            const observer = new MutationObserver(records => {
                subscriber.next(records);
            });
            observer.observe(nativeElement, config);
            return () => {
                observer.disconnect();
            };
        });
    }
}
/** @nocollapse */
MutationObserverService.ɵfac = function MutationObserverService_Factory(t) { return new (t || MutationObserverService)(ɵngcc0.ɵɵinject(ElementRef), ɵngcc0.ɵɵinject(MUTATION_OBSERVER_INIT)); };
/** @nocollapse */
MutationObserverService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MutationObserverService, factory: MutationObserverService.ɵfac });
/** @nocollapse */
MutationObserverService.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MUTATION_OBSERVER_INIT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MutationObserverService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MUTATION_OBSERVER_INIT]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MutationObserverModule {
}
/** @nocollapse */
MutationObserverModule.ɵfac = function MutationObserverModule_Factory(t) { return new (t || MutationObserverModule)(); };
/** @nocollapse */
MutationObserverModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MutationObserverModule });
/** @nocollapse */
MutationObserverModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MutationObserverModule, [{
        type: NgModule,
        args: [{
                declarations: [MutationObserverDirective],
                exports: [MutationObserverDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MutationObserverModule, { declarations: [MutationObserverDirective], exports: [MutationObserverDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MutationObserverDirective, MutationObserverService, MUTATION_OBSERVER_INIT, MutationObserverModule, mutationObserverInitFactory as ɵa };

